/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Try_File_LabelInputs */

const en_mcp_try_file_label = /** @type {(inputs: Mcp_Try_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local file (CLI)`)
};

const es_mcp_try_file_label = /** @type {(inputs: Mcp_Try_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo local (CLI)`)
};

/**
* | output |
* | --- |
* | "Local file (CLI)" |
*
* @param {Mcp_Try_File_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_try_file_label = /** @type {((inputs?: Mcp_Try_File_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Try_File_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_try_file_label(inputs)
	return en_mcp_try_file_label(inputs)
});